// extracted by mini-css-extract-plugin
module.exports = {"module":"RightScrollable_module__2NSUb","mobile":"RightScrollable_mobile__3tkkr","thinDesktop":"RightScrollable_thinDesktop__3AOF5"};